module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Wallet2-bd53c026cfdd830ceaec86ebc46ebcbe.svg";